import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default function TextReveal({
  children,
  as: Tag = 'div',
  className = '',
  stagger = 0.06,
  duration = 1.1,
  triggerStart = 'top 88%',
  delay = 0,
  ...props
}) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: no-preference)', () => {
      const split = new SplitText(el, { type: 'lines,words', mask: 'lines', linesClass: 'ob-reveal-line', wordsClass: 'ob-reveal-word' });
      gsap.set(split.words, { yPercent: 110, rotate: 3, opacity: 0 });
      const tween = gsap.to(split.words, {
        yPercent: 0,
        rotate: 0,
        opacity: 1,
        duration,
        delay,
        stagger,
        ease: 'expo.out',
        paused: true,
      });
      const st = ScrollTrigger.create({
        trigger: el,
        start: triggerStart,
        once: true,
        onEnter: () => tween.play(),
      });
      return () => {
        st.kill();
        tween.kill();
        split.revert();
      };
    });

    return () => mm.revert();
  }, [children, stagger, duration, triggerStart, delay]);

  return (
    <Tag ref={ref} className={`ob-reveal ${className}`} {...props}>
      {children}
    </Tag>
  );
}
